import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';

export default ErrorBoundary;
